import React from 'react'
import { withStyles } from '@mui/styles'
import { Box, Container } from '@mui/material'


import { ConsultComponent } from '../../../features/consult'
import { useCombos } from '../../../features/combos'
import { CONSULT_COMBOS_IDS } from '../constants'
import { consultStyles } from './consult.styles'

export const ConsultPage = withStyles(consultStyles)(({ classes }) => {
  useCombos(CONSULT_COMBOS_IDS)

  return (
    <div className={classes.root}>
      <Container className={classes.container} maxWidth="lg">
        <Box bgcolor="common.white" borderRadius={4} p={[2, 5]} mt={[1, 3]}>
          <ConsultComponent />
        </Box>
      </Container>
    </div>
  )
})
